(() => {
  const script = document.currentScript;
  const stylesheetUrl = script?.dataset.cwStylesheet;
  const styleId = 'cw-pandectes-redesign';
  const observedRoots = new WeakSet();
  let stylesheetPromise;

  if (!stylesheetUrl) return;

  const loadStylesheet = () => {
    if (!stylesheetPromise) {
      stylesheetPromise = fetch(stylesheetUrl, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : ''))
        .catch(() => '');
    }

    return stylesheetPromise;
  };

  const appendStyles = (root, cssText) => {
    if (!cssText || root.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = cssText;
    root.appendChild(style);
  };

  const labelLanguageControls = (root) => {
    root.querySelectorAll('select[name="language"]').forEach((select) => {
      if (select.getAttribute('aria-label')?.trim() || select.getAttribute('aria-labelledby')?.trim() || select.labels?.length) return;
      const language = select.value || document.documentElement.lang;
      select.setAttribute('aria-label', /^de(?:[-_]|$)/i.test(language) ? 'Sprache' : 'Language');
    });
  };

  const updateRoot = (root, cssText) => {
    appendStyles(root, cssText);
    labelLanguageControls(root);
  };

  const observeRoot = (root, cssText) => {
    if (observedRoots.has(root)) return;

    observedRoots.add(root);
    new MutationObserver(() => updateRoot(root, cssText)).observe(root, { childList: true, subtree: true });
  };

  const install = async (host, attempt = 0) => {
    const root = host.shadowRoot;

    if (!root) {
      if (attempt < 30) window.setTimeout(() => install(host, attempt + 1), 100);
      return;
    }

    const cssText = await loadStylesheet();
    if (!host.isConnected || !host.shadowRoot) return;

    updateRoot(host.shadowRoot, cssText);
    observeRoot(host.shadowRoot, cssText);
  };

  const scan = () => {
    document.querySelectorAll('pandectes-cmp').forEach((host) => install(host));
  };

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
